import React, { useEffect, useState } from "react";
import "./ReplayPlayerWindow.scss";
import {
  AspectRatio,
  HandEventType,
  isDevReact,
  nFormatter
} from "../api/ReplayVariables";
import { useTranslation } from "react-i18next";
import { Cards } from "../api/ReplayVariables";
import ChipsLabel from "./ChipsLabel";
import { getRepositionedSeat } from "../api/ReplayPlayer";
import NumberFormat from "react-number-format";
import PlayerWindowPositions from "../api/PlayerWindowPositions";
import { Tooltip } from "@material-ui/core";
import HUDLabel from "./hud/HUDLabel";
import { tokenLevel } from "../api/SpaceKoToken";

const TOOLTIP_DELAY = 300;

function ReplayPlayerWindow({
  seats,
  player,
  stats,
  hero,
  mainSeat,
  preferredSeat,
  top,
  left,
  imgPosition,
  zonePosition,
  realTableRatio,
  bigBlind,
  potSize,
  bbMode,
  spaceKo = false,
  buyIn = 0,
  anonymous,
  showAllCards,
  onMove,
  onBBModeChanged = ()=>{
    console.log("onBBModeChanged");
  }
})
{
  
  // v2-1379 : 0 hors Space KO, ce qui laisse la pastille rouge des autres KO intacte
  const spaceKoLevel = spaceKo ? tokenLevel(player.bounty, buyIn) : 0;

  const [askShowHUD, setAskShowHUD] = useState(false);
  const [showHUD, setShowHUD] = useState(false);
  const [hideHUD, setHideHUD] = useState(false);

  let startPosition = { x: 0, y: 0 };
  let dragging = false;
  let repositionedSeat = getRepositionedSeat(
    player.seat,
    seats,
    preferredSeat,
    mainSeat
  );

  const onDragStart = (evt) => {
    startPosition = { x: evt.screenX, y: evt.screenY };
    //console.log("onDragStart", startPosition);
  };
  const onDrag = (evt) => {
    dragging = true;
    //console.log("drag", evt);
  };
  const onDragEnd = (evt) => {
    if (dragging) {
      //console.log("repositionedSeat", repositionedSeat);

      let newPosition = { x: evt.screenX, y: evt.screenY };
      //console.log("onDragEnd", newPosition);
      let diff = {
        x: Math.floor((newPosition.x - startPosition.x) / realTableRatio),
        y: Math.floor((newPosition.y - startPosition.y) / realTableRatio)
      };
      //console.log("diff", diff);
      //console.log(
      //  "before:" +
      //    PlayerWindowPositions[seats + "_" + repositionedSeat + "_top"]
      //);
      let newTop =
        PlayerWindowPositions[seats + "_" + repositionedSeat + "_top"] + diff.y;
      let newLeft =
        PlayerWindowPositions[seats + "_" + repositionedSeat + "_left"] +
        diff.x;
      PlayerWindowPositions[seats + "_" + repositionedSeat + "_top"] = newTop;
      PlayerWindowPositions[seats + "_" + repositionedSeat + "_left"] = newLeft;
      dragging = false;
      //console.log(
      //  "after PlayerWindowPositions[" +
      //    seats +
      //    "_" +
      //    repositionedSeat +
      //    "_top" +
      //    "]:" +
      //    PlayerWindowPositions[seats + "_" + repositionedSeat + "_top"]
      //);
      //console.log("diff", diff);
      //console.log(PlayerWindowPositions);
      onMove();
    }
  };

  const { t } = useTranslation();

  let className = "";
  if (player.playing) {
    if (player.current) {
      if (player.eventType === HandEventType.FOLD) {
        className = "player current folded";
      } else {
        className = "player current";
      }
    } else {
      className = "player";
    }
  } else {
    if (player.pseudo.toLowerCase() === hero.toLowerCase()) {
      className = "player hero folded";
    } else {
      if (player.eventType === HandEventType.FOLD) {
        className = "player current folded";
      } else {
        className = "player folded";
      }
    }
  }

  let pseudo = anonymous
    ? player.pseudo.toLowerCase() === hero.toLowerCase()
      ? t("hero")
      : t("player") + " " + player.seat
    : player.pseudo;

  if (player.pseudo === "") {
    pseudo = "";
    className += " empty";
  }

  if (stats)
  {
    className += " has-stats";
  }

  const getTable = () =>
  {
    return (
      <div
        draggable={isDevReact()}
        onDragStart={onDragStart}
        onDragEnd={onDragEnd}
        onDrag={onDrag}
        onMouseOver={(evt) => { evt.stopPropagation();setHideHUD(false);setAskShowHUD(true) }}
        onMouseOut={ ()=>setHideHUD(true)}
        className={className}
        style={{
          top: top + "px",
          left: left + "px",
          width: AspectRatio.refPlayerWidth * realTableRatio + "px",
          fontSize: AspectRatio.refFontSize * realTableRatio + "px"
        }}>
      <table
      >
        <tbody>
          <tr>
            <td
              className="percentage"
              style={{
                fontSize: AspectRatio.refFontSize * realTableRatio * 1.2 + "px",
                lineHeight:
                  AspectRatio.refFontSize * realTableRatio * 1.2 + "px"
              }}
            >
              {(player.showedCards || showAllCards) &&
              player.percentage !== -1 ? (
                <span className="value">
                  &nbsp;
                  <NumberFormat
                    value={player.percentage}
                    displayType={"text"}
                    thousandSeparator={true}
                    decimalScale="2"
                    renderText={(value) => (
                      <>
                        {value}%{player.amountToCall > 0 ? <>&nbsp;</> : ""}
                      </>
                    )}
                  />
                  &nbsp;
                </span>
              ) : player.amountToCall > 0 ? (
                ""
              ) : (
                <span>&nbsp;</span>
              )}

                {player.amountToCall > 0 && player.chips > 0 ? (
                  <>
                    <span className="pot-odd">
                      &nbsp;
                      <NumberFormat
                        value={potSize / player.amountToCall}
                        displayType={"text"}
                        thousandSeparator={true}
                        decimalScale="1"
                        renderText={(value) => <>{value}</>}
                      />&nbsp;|&nbsp;<span className="equity">
                        { Math.round(100/((potSize / player.amountToCall)+1))}%
                      </span>
                      &nbsp;
                    </span>
                  </>
              ) : (
                <span>&nbsp;</span>
              )}
            </td>
          </tr>
          <tr>
            <td className={"cards cards" + player.cards.length}>
              <div className="d-flex justify-content-center">
                {player.cards.map((card, index) => (
                  <img
                    key={index}
                    className={
                      player.cards.length === 2
                        ? "cardHalf"
                        : index < player.cards.length - 1
                        ? "cardQuarter"
                        : "cardHalf"
                    }
                    src={
                      Cards[
                        (player.cards.length === 2
                          ? "cardHalfFirst"
                          : index < player.cards.length - 1
                          ? "cardQuarter"
                          : "cardHalf") +
                          (card !== -1 &&
                          (player.showedCards ||
                            showAllCards ||
                            player.pseudo.toLowerCase() === hero.toLowerCase())
                            ? card
                            : "Unknown")
                      ]
                    }
                    alt=""
                  />
                ))}
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <table className="label">
                <tbody>
                  <tr>
                    <td
                      className="pseudo d-flex"
                      style={{
                        width:
                          AspectRatio.refPlayerWidth * realTableRatio + "px",
                        fontSize:
                          AspectRatio.refFontSize * realTableRatio * 1.2 + "px"
                      }}
                    >
                      <div className="text w-100">
                        &nbsp;
                          {pseudo}
                        &nbsp;
        {player.bounty>0 ?
          <span className={spaceKoLevel > 0 ? "bounty space-ko-" + spaceKoLevel : "bounty"}>{player.bounty}</span>:<></>
        }
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td
                      className="bottom d-flex"
                      style={{
                        lineHeight:
                          AspectRatio.refLineHeight * realTableRatio * 1.4 +
                          "px",
                        fontSize:
                          AspectRatio.refFontSize * realTableRatio * 1.4 + "px"
                      }}
                    >
                      <div className="chips w-100" onClick={onBBModeChanged}>
                        &nbsp;&nbsp;&nbsp;
                        {player.pseudo !== "" ? (
                          bbMode ? (
                            <>
                              {nFormatter(Math.abs(player.chips / bigBlind))} BB
                            </>
                          ) : (
                            <>
                              {player.chips > 0
                                ? nFormatter(Math.abs(player.chips))
                                : 0}
                            </>
                          )
                        ) : (
                          ""
                        )}
                        &nbsp;&nbsp;&nbsp;
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td
                        className={"action "+(player.eventType === "NONE"?"none":"")}
                      style={{
                        lineHeight:
                          AspectRatio.refLineHeight * realTableRatio +
                          "px",
                        fontSize:
                          AspectRatio.refFontSize * realTableRatio + "px"
                      }}
                    >
                      {player.eventType === "NONE" || player.eventType === "" ? (
                        <div>NONE</div>
                      ) : (
                        <>
                          <div>{t("events." + player.eventType)}</div>
                        </>
                      )}
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>
        </tbody>
      </table>
</div>
    );
  }

  useEffect(() =>
  {
    //console.log("hide?", hideHUD);
    let hideTimer = null;
    let showTimer = null;
    
    if (hideHUD)
    {
      hideTimer = setTimeout(() =>
      {
        //console.log("checking2:" + hideHUD);
        setHideHUD(false);
        setAskShowHUD(false);
        setShowHUD(false);
      }, TOOLTIP_DELAY);
    }
    if (askShowHUD)
    {
      showTimer = setTimeout(() =>
      {
        //console.log("checking2:" + hideHUD);
        setHideHUD(false);
        setAskShowHUD(false);
        setShowHUD(true);
      }, TOOLTIP_DELAY);
    }
    return (() =>
    {
      if (hideTimer)
      {
        clearTimeout(hideTimer);
      }
      if (showTimer)
      {
        clearTimeout(showTimer);
      }
    });
  }, [hideHUD, showHUD, askShowHUD]);
  return (
    <>
      <ChipsLabel
        key={Math.random()}
        seats={seats}
        player={player}
        seat={repositionedSeat}
        imgPosition={imgPosition}
        zonePosition={zonePosition}
        realTableRatio={realTableRatio}
        bbMode={bbMode}
        bigBlind={bigBlind}
        onMove={onMove}
      ></ChipsLabel>
      {stats ?
        <Tooltip title={<HUDLabel stats={stats} onMouseOver={(evt) => { setHideHUD(false); setAskShowHUD(true); evt.stopPropagation(); }} onMouseOut={() => setHideHUD(true)}></HUDLabel>} open={showHUD} interactive={true} arrow={false} TransitionProps={{ timeout: 0 }}>{getTable()}
        </Tooltip> :
        getTable()}
    </>
  );
}
export default ReplayPlayerWindow;
